<template>
  <div>
    <div class="homeTeam" v-if="$store.state.webNavigator=='pc'">
      <div class="home-team marginAuto">
        <div>
          <p class="part-title list-tlt displayIB" style="width: 100%">3大团队·脂玫乐健康瘦身更专业<span
            class="list-tlt-tip">-</span>
          </p>
        </div>
        <div class="swiper-container banner3 home-team-bar home-rol">
          <div class="swiper-wrapper">
            <div class="swiper-slide" 
            v-for="(item,index) in rolllist2" 
            :key="index"
            >
              <img class="home-team-img" :src="item" alt="3大团队·脂玫乐健康瘦身更专业" title=""/>
            </div>
          </div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    <div v-else class="phone-page">
      <div class="home-team">
        <div class="PhoneHome-title">3大团队 <span class="col00CDA2">-</span><br>脂玫乐健康瘦身更专业</div>
        <div class="swiper-container bannerTeam home-team-bar">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in rolllist2Phone" :key="index">
              <img class="home-team-img" :src="httptype(item)" alt="3大团队·脂玫乐健康瘦身更专业" title=""/>
            </div>
          </div>
          <div id="phoneTeam-pagination" class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { myFun } from "../../../../plug/modifyImagePath"
export default {
  name: 'homeTeam',
  props: {
    loadType: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      imgUrl: 'https://jusexcx.zmelo.com/',
      rolllist2: myFun([
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/RotationChart/nav2-1.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/RotationChart/nav2-2.png',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/RotationChart/nav2-3.png',
      ]),
      rolllist2Phone: myFun([
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/RotationChart/NavImg2-1.jpg',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/RotationChart/NavImg2-2.jpg',
        'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/RotationChart/NavImg2-3.jpg',
      ]),
      alt1:'3大团队·脂玫乐健康瘦身更专业',
      outstyleOne:{
        width: "100%",
        height: 665*(100/750)+"vw",
      }
    };
  },
  watch: {},
  methods: {
    httptype (url) { // 图片判断
      if (url) {
        url.toString();
        if (url.indexOf('http') == '-1') {
          return this.imgUrl + url;
        } else {
          return url;
        }
      }
      return '';
    },
    initSwiper3 () {
      this.$store.dispatch('getSwiper', () => {
        // 广告轮播图
        this.banner3 = new Swiper('.banner3', {
          loop: true,
          autoHeight: true,
          autoplay: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      });
    },
    initSwiper4 () {
      this.$store.dispatch('getSwiper', () => {
        // 广告轮播图
        this.bannerTeam = new Swiper('.bannerTeam', {
          loop: true,
          autoHeight: true,
          autoplay: true,
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // },
          pagination: {
            el: '#phoneTeam-pagination',
          },
        });
      });
    },
  },
  mounted () {
    this.$store.state.webNavigator == 'pc' ? this.initSwiper3() : this.initSwiper4();
  },
};
</script>

<style lang="less" scoped>
  @import url('../../../../../static/css/fontSize.less');
  @media screen and (max-width: 800px) {
    .home-team{
      padding: 70*@width1 0 0;
    }
    .PhoneHome-title{
      margin-bottom: 36*@width1;
    }
    .home-team-bar,.home-team-img{
      width: 100%;
      height: 665*@width1;
    }
  }
  @media screen and (min-width: 800px) {
    .homeTeam{
      // margin-bottom: 45*@width;
    }
    .home-team,.home-team-img{
      width: 700*@width;
    }
    .home-team-img{
      height: 263*@width;
    }
    .home-team-bar{
      margin-top: 20*@width;
    }
  }
</style>
<style lang="less">
  @import url('../../../../../static/css/fontSize.less');
  @media screen and (max-width: 800px) {
    #phoneTeam-pagination{
      bottom: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height:31*@width1 !important;
      background:rgba(0,205,162,0.9) !important;
      line-height: 19*@width1 !important;
    }
    #phoneTeam-pagination>.swiper-pagination-bullet {
      width: 34 * @width1;
      height: 5 * @width1;
      background: #FFFFFF;
      border-radius: 2 * @width1;
    }
    #phoneTeam-pagination>.swiper-pagination-bullet-active {
      background: #FFFFFF;
    }
  }

</style>



// WEBPACK FOOTER //
// homeTeam.vue